/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2TransactionType = exports.V2OrderItemOrderItemCategory = exports.V1TransactionStatus = exports.TransactionTransactionType = exports.TransactionTransactionStatus = exports.TransactionStatusStatus = exports.SubscriptionStatus = exports.SubscriptionFrequency = exports.SavePaymentMethodDisplayOption = exports.RefundType = exports.RefundStatus = exports.RedirectTarget = exports.Reason = exports.RateLimiterTimeFrame = exports.RateLimiterFeature = exports.RateLimiterDomain = exports.ProviderRefundStatus = exports.ProviderAccountStatus = exports.PaymentMethodType = exports.PaymentMethodStatus = exports.PanType = exports.OrderStatusStatus = exports.OrderSnapshotStatus = exports.OrderOrderType = exports.OrderOrderItemOrderItemCategory = exports.OrderDescriptionOrderType = exports.MethodType = exports.MerchantV2TransactionStatus = exports.MerchantCapability = exports.FrequencyType = exports.FlowType = exports.DurationUnit = exports.Domain = exports.CreditCardNetwork = exports.CheckoutType = exports.ChargeIntent = exports.CaptureMethod = exports.AmountType = exports.AllowMerchantUseDisplayOption = exports.Action = void 0;
var Action;
(function (Action) {
    Action["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    Action["VOID"] = "VOID";
    Action["CAPTURE"] = "CAPTURE";
})(Action = exports.Action || (exports.Action = {}));
var AllowMerchantUseDisplayOption;
(function (AllowMerchantUseDisplayOption) {
    AllowMerchantUseDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    AllowMerchantUseDisplayOption["SHOW_ALLOW_MERCHANT_USE_CHECKBOX"] = "SHOW_ALLOW_MERCHANT_USE_CHECKBOX";
})(AllowMerchantUseDisplayOption = exports.AllowMerchantUseDisplayOption || (exports.AllowMerchantUseDisplayOption = {}));
var AmountType;
(function (AmountType) {
    AmountType["UNKNOWN"] = "UNKNOWN";
    AmountType["FIXED"] = "FIXED";
    AmountType["MAXIMUM"] = "MAXIMUM";
})(AmountType = exports.AmountType || (exports.AmountType = {}));
var CaptureMethod;
(function (CaptureMethod) {
    CaptureMethod["UNKNOWN_CAPTURE_METHOD"] = "UNKNOWN_CAPTURE_METHOD";
    CaptureMethod["IMMEDIATE"] = "IMMEDIATE";
    CaptureMethod["DELAYED"] = "DELAYED";
    CaptureMethod["FORCE_MANUAL"] = "FORCE_MANUAL";
    CaptureMethod["AUTOMATIC"] = "AUTOMATIC";
    CaptureMethod["PREFER_MANUAL"] = "PREFER_MANUAL";
})(CaptureMethod = exports.CaptureMethod || (exports.CaptureMethod = {}));
var ChargeIntent;
(function (ChargeIntent) {
    ChargeIntent["UNDEFINED"] = "UNDEFINED";
    ChargeIntent["SALE"] = "SALE";
    ChargeIntent["RECURRING"] = "RECURRING";
})(ChargeIntent = exports.ChargeIntent || (exports.ChargeIntent = {}));
var CheckoutType;
(function (CheckoutType) {
    CheckoutType["UNKNOWN"] = "UNKNOWN";
    CheckoutType["REGULAR"] = "REGULAR";
    CheckoutType["EXPRESS"] = "EXPRESS";
})(CheckoutType = exports.CheckoutType || (exports.CheckoutType = {}));
var CreditCardNetwork;
(function (CreditCardNetwork) {
    CreditCardNetwork["UNDEFINED_NETWORK"] = "UNDEFINED_NETWORK";
    CreditCardNetwork["AMEX"] = "AMEX";
    CreditCardNetwork["CARTES_BANCAIRES"] = "CARTES_BANCAIRES";
    CreditCardNetwork["CHINA_UNION_PAY"] = "CHINA_UNION_PAY";
    CreditCardNetwork["DISCOVER"] = "DISCOVER";
    CreditCardNetwork["EFTPOS"] = "EFTPOS";
    CreditCardNetwork["ELECTRON"] = "ELECTRON";
    CreditCardNetwork["ELO"] = "ELO";
    CreditCardNetwork["INTERAC"] = "INTERAC";
    CreditCardNetwork["JCB"] = "JCB";
    CreditCardNetwork["MADA"] = "MADA";
    CreditCardNetwork["MAESTRO"] = "MAESTRO";
    CreditCardNetwork["MASTER_CARD"] = "MASTER_CARD";
    CreditCardNetwork["PRIVATE_LABEL"] = "PRIVATE_LABEL";
    CreditCardNetwork["VISA"] = "VISA";
    CreditCardNetwork["VPAY"] = "VPAY";
    CreditCardNetwork["BANCONTACT_CARD"] = "BANCONTACT_CARD";
})(CreditCardNetwork = exports.CreditCardNetwork || (exports.CreditCardNetwork = {}));
var Domain;
(function (Domain) {
    Domain["UNDEFINED"] = "UNDEFINED";
    Domain["ORDER"] = "ORDER";
    Domain["CREDIT_CARD"] = "CREDIT_CARD";
    Domain["SAVED_CREDIT_CARD"] = "SAVED_CREDIT_CARD";
    Domain["PAYMENT_METHOD"] = "PAYMENT_METHOD";
})(Domain = exports.Domain || (exports.Domain = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["UNKNOWN_DURATION_UNIT"] = "UNKNOWN_DURATION_UNIT";
    DurationUnit["MINUTE"] = "MINUTE";
    DurationUnit["HOUR"] = "HOUR";
    DurationUnit["DAY"] = "DAY";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
var FlowType;
(function (FlowType) {
    FlowType["NA"] = "NA";
    FlowType["SYNC"] = "SYNC";
    FlowType["ASYNC"] = "ASYNC";
})(FlowType = exports.FlowType || (exports.FlowType = {}));
var FrequencyType;
(function (FrequencyType) {
    FrequencyType["UNKNOWN"] = "UNKNOWN";
    FrequencyType["DAY"] = "DAY";
    FrequencyType["WEEK"] = "WEEK";
    FrequencyType["MONTH"] = "MONTH";
    FrequencyType["YEAR"] = "YEAR";
    FrequencyType["SPORADIC"] = "SPORADIC";
})(FrequencyType = exports.FrequencyType || (exports.FrequencyType = {}));
var MerchantCapability;
(function (MerchantCapability) {
    MerchantCapability["UNDEFINED_CAPABILITY"] = "UNDEFINED_CAPABILITY";
    MerchantCapability["SUPPORTS_3DS"] = "SUPPORTS_3DS";
    MerchantCapability["SUPPORTS_EMV"] = "SUPPORTS_EMV";
    MerchantCapability["SUPPORTS_CREDIT"] = "SUPPORTS_CREDIT";
    MerchantCapability["SUPPORTS_DEBIT"] = "SUPPORTS_DEBIT";
})(MerchantCapability = exports.MerchantCapability || (exports.MerchantCapability = {}));
var MerchantV2TransactionStatus;
(function (MerchantV2TransactionStatus) {
    MerchantV2TransactionStatus["UNDEFINED"] = "UNDEFINED";
    MerchantV2TransactionStatus["INITIALIZED"] = "INITIALIZED";
    MerchantV2TransactionStatus["IN_PROCESS"] = "IN_PROCESS";
    MerchantV2TransactionStatus["APPROVED"] = "APPROVED";
    MerchantV2TransactionStatus["PENDING"] = "PENDING";
    MerchantV2TransactionStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    MerchantV2TransactionStatus["PENDING_BUYER"] = "PENDING_BUYER";
    MerchantV2TransactionStatus["BUYER_CANCELED"] = "BUYER_CANCELED";
    MerchantV2TransactionStatus["TIMEOUT"] = "TIMEOUT";
    MerchantV2TransactionStatus["REFUND"] = "REFUND";
    MerchantV2TransactionStatus["PARTIAL_REFUND"] = "PARTIAL_REFUND";
    MerchantV2TransactionStatus["VOID"] = "VOID";
    MerchantV2TransactionStatus["CHARGE_BACK"] = "CHARGE_BACK";
    MerchantV2TransactionStatus["EXPIRED"] = "EXPIRED";
    MerchantV2TransactionStatus["DECLINED"] = "DECLINED";
    MerchantV2TransactionStatus["FAILED"] = "FAILED";
    MerchantV2TransactionStatus["COMPLETED_FUNDS_HELD"] = "COMPLETED_FUNDS_HELD";
    MerchantV2TransactionStatus["TPA_CANCELED"] = "TPA_CANCELED";
    MerchantV2TransactionStatus["OFFLINE"] = "OFFLINE";
    MerchantV2TransactionStatus["DISPUTE"] = "DISPUTE";
    MerchantV2TransactionStatus["AUTHORIZED"] = "AUTHORIZED";
})(MerchantV2TransactionStatus = exports.MerchantV2TransactionStatus || (exports.MerchantV2TransactionStatus = {}));
var MethodType;
(function (MethodType) {
    MethodType["UNDEFINED"] = "UNDEFINED";
    MethodType["ONLINE"] = "ONLINE";
    MethodType["FACE_TO_FACE"] = "FACE_TO_FACE";
})(MethodType = exports.MethodType || (exports.MethodType = {}));
var OrderDescriptionOrderType;
(function (OrderDescriptionOrderType) {
    OrderDescriptionOrderType["UNDEFINED"] = "UNDEFINED";
    OrderDescriptionOrderType["ONE_TIME"] = "ONE_TIME";
    OrderDescriptionOrderType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(OrderDescriptionOrderType = exports.OrderDescriptionOrderType || (exports.OrderDescriptionOrderType = {}));
var OrderOrderItemOrderItemCategory;
(function (OrderOrderItemOrderItemCategory) {
    OrderOrderItemOrderItemCategory["UNDEFINED"] = "UNDEFINED";
    OrderOrderItemOrderItemCategory["PHYSICAL"] = "PHYSICAL";
    OrderOrderItemOrderItemCategory["DIGITAL"] = "DIGITAL";
})(OrderOrderItemOrderItemCategory = exports.OrderOrderItemOrderItemCategory || (exports.OrderOrderItemOrderItemCategory = {}));
var OrderOrderType;
(function (OrderOrderType) {
    OrderOrderType["OneTime"] = "OneTime";
    OrderOrderType["Recurring"] = "Recurring";
})(OrderOrderType = exports.OrderOrderType || (exports.OrderOrderType = {}));
var OrderSnapshotStatus;
(function (OrderSnapshotStatus) {
    OrderSnapshotStatus["Initialized"] = "Initialized";
    OrderSnapshotStatus["InProcess"] = "InProcess";
    OrderSnapshotStatus["Expired"] = "Expired";
    OrderSnapshotStatus["NotApproved"] = "NotApproved";
    OrderSnapshotStatus["Approved"] = "Approved";
    OrderSnapshotStatus["SubscriptionPending"] = "SubscriptionPending";
    OrderSnapshotStatus["SubscriptionActive"] = "SubscriptionActive";
    OrderSnapshotStatus["SubscriptionCancel"] = "SubscriptionCancel";
    OrderSnapshotStatus["SubscriptionFinished"] = "SubscriptionFinished";
    OrderSnapshotStatus["SubscriptionSuspended"] = "SubscriptionSuspended";
})(OrderSnapshotStatus = exports.OrderSnapshotStatus || (exports.OrderSnapshotStatus = {}));
var OrderStatusStatus;
(function (OrderStatusStatus) {
    OrderStatusStatus["UNDEFINED"] = "UNDEFINED";
    OrderStatusStatus["INITIALIZED"] = "INITIALIZED";
    OrderStatusStatus["IN_PROCESS"] = "IN_PROCESS";
    OrderStatusStatus["EXPIRED"] = "EXPIRED";
    OrderStatusStatus["NOT_APPROVED"] = "NOT_APPROVED";
    OrderStatusStatus["APPROVED"] = "APPROVED";
    OrderStatusStatus["PENDING_EXPIRATION"] = "PENDING_EXPIRATION";
    OrderStatusStatus["SUBSCRIPTION_ACTIVE"] = "SUBSCRIPTION_ACTIVE";
    OrderStatusStatus["SUBSCRIPTION_CANCELLED"] = "SUBSCRIPTION_CANCELLED";
    OrderStatusStatus["SUBSCRIPTION_FINISHED"] = "SUBSCRIPTION_FINISHED";
    OrderStatusStatus["SUBSCRIPTION_PENDING"] = "SUBSCRIPTION_PENDING";
    OrderStatusStatus["SUBSCRIPTION_SUSPENDED"] = "SUBSCRIPTION_SUSPENDED";
})(OrderStatusStatus = exports.OrderStatusStatus || (exports.OrderStatusStatus = {}));
var PanType;
(function (PanType) {
    PanType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    PanType["FPAN"] = "FPAN";
    PanType["DPAN"] = "DPAN";
})(PanType = exports.PanType || (exports.PanType = {}));
var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["SELECTED"] = "SELECTED";
    PaymentMethodStatus["CONNECTED"] = "CONNECTED";
})(PaymentMethodStatus = exports.PaymentMethodStatus || (exports.PaymentMethodStatus = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["ONLINE_METHOD"] = "ONLINE_METHOD";
    PaymentMethodType["OFFLINE_METHOD"] = "OFFLINE_METHOD";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var ProviderAccountStatus;
(function (ProviderAccountStatus) {
    ProviderAccountStatus["UNKNOWN"] = "UNKNOWN";
    ProviderAccountStatus["NOT_CLAIMED"] = "NOT_CLAIMED";
    ProviderAccountStatus["FUNDS_HELD"] = "FUNDS_HELD";
    ProviderAccountStatus["CLAIMED"] = "CLAIMED";
    ProviderAccountStatus["BLOCKED"] = "BLOCKED";
    ProviderAccountStatus["SUSPENDED"] = "SUSPENDED";
    ProviderAccountStatus["MUST_BE_CLAIMED"] = "MUST_BE_CLAIMED";
})(ProviderAccountStatus = exports.ProviderAccountStatus || (exports.ProviderAccountStatus = {}));
var ProviderRefundStatus;
(function (ProviderRefundStatus) {
    ProviderRefundStatus["SUCCEEDED"] = "SUCCEEDED";
    ProviderRefundStatus["DECLINED"] = "DECLINED";
    ProviderRefundStatus["PENDING"] = "PENDING";
    ProviderRefundStatus["FAILURE"] = "FAILURE";
})(ProviderRefundStatus = exports.ProviderRefundStatus || (exports.ProviderRefundStatus = {}));
var RateLimiterDomain;
(function (RateLimiterDomain) {
    RateLimiterDomain["UNDEFINED_DOMAIN"] = "UNDEFINED_DOMAIN";
    RateLimiterDomain["PAYMENT_PROCESSING_CHARGE_PER_SITE"] = "PAYMENT_PROCESSING_CHARGE_PER_SITE";
    RateLimiterDomain["PAYMENT_PROCESSING_CHARGE_PER_SITE_USER"] = "PAYMENT_PROCESSING_CHARGE_PER_SITE_USER";
    RateLimiterDomain["PAYMENT_PROCESSING_CHARGE_PER_SITE_ID"] = "PAYMENT_PROCESSING_CHARGE_PER_SITE_ID";
    RateLimiterDomain["PAYMENT_PROCESSING_CHARGE_PER_SITE_IP_PAYMENT_METHOD"] = "PAYMENT_PROCESSING_CHARGE_PER_SITE_IP_PAYMENT_METHOD";
})(RateLimiterDomain = exports.RateLimiterDomain || (exports.RateLimiterDomain = {}));
var RateLimiterFeature;
(function (RateLimiterFeature) {
    RateLimiterFeature["UNDEFINED_FEATURE"] = "UNDEFINED_FEATURE";
    RateLimiterFeature["MERCHANT_INITIATED_TRANSACTION"] = "MERCHANT_INITIATED_TRANSACTION";
    RateLimiterFeature["MSID_IP_DECLINES"] = "MSID_IP_DECLINES";
    RateLimiterFeature["CAPTCHA"] = "CAPTCHA";
})(RateLimiterFeature = exports.RateLimiterFeature || (exports.RateLimiterFeature = {}));
var RateLimiterTimeFrame;
(function (RateLimiterTimeFrame) {
    RateLimiterTimeFrame["Undefined"] = "Undefined";
    RateLimiterTimeFrame["Minutes"] = "Minutes";
    RateLimiterTimeFrame["Hourly"] = "Hourly";
    RateLimiterTimeFrame["Daily"] = "Daily";
    RateLimiterTimeFrame["Weekly"] = "Weekly";
    RateLimiterTimeFrame["Monthly"] = "Monthly";
    RateLimiterTimeFrame["Yearly"] = "Yearly";
    RateLimiterTimeFrame["Total"] = "Total";
})(RateLimiterTimeFrame = exports.RateLimiterTimeFrame || (exports.RateLimiterTimeFrame = {}));
var Reason;
(function (Reason) {
    Reason["ALREADY_REFUNDED"] = "ALREADY_REFUNDED";
    Reason["PROVIDER_IS_DOWN"] = "PROVIDER_IS_DOWN";
    Reason["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    Reason["PENDING_REFUND"] = "PENDING_REFUND";
    Reason["EXPIRED"] = "EXPIRED";
    Reason["FORBIDDEN"] = "FORBIDDEN";
})(Reason = exports.Reason || (exports.Reason = {}));
var RedirectTarget;
(function (RedirectTarget) {
    RedirectTarget["SAME_WINDOW"] = "SAME_WINDOW";
    RedirectTarget["NEW_WINDOW"] = "NEW_WINDOW";
    RedirectTarget["EMBEDDED"] = "EMBEDDED";
})(RedirectTarget = exports.RedirectTarget || (exports.RedirectTarget = {}));
var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "PENDING";
    RefundStatus["SUCCEEDED"] = "SUCCEEDED";
    RefundStatus["FAILED"] = "FAILED";
})(RefundStatus = exports.RefundStatus || (exports.RefundStatus = {}));
var RefundType;
(function (RefundType) {
    RefundType["PARTIAL"] = "PARTIAL";
    RefundType["FULL"] = "FULL";
})(RefundType = exports.RefundType || (exports.RefundType = {}));
var SavePaymentMethodDisplayOption;
(function (SavePaymentMethodDisplayOption) {
    SavePaymentMethodDisplayOption["SHOW_NOTHING"] = "SHOW_NOTHING";
    SavePaymentMethodDisplayOption["SHOW_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_DISCLAIMER"] = "SHOW_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX"] = "SHOW_MERCHANT_SAVE_PAYMENT_METHOD_CHECKBOX";
    SavePaymentMethodDisplayOption["SHOW_MERCHANT_DISCLAIMER"] = "SHOW_MERCHANT_DISCLAIMER";
    SavePaymentMethodDisplayOption["SHOW_VISITOR_DISCLAIMER"] = "SHOW_VISITOR_DISCLAIMER";
})(SavePaymentMethodDisplayOption = exports.SavePaymentMethodDisplayOption || (exports.SavePaymentMethodDisplayOption = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["SUBSCRIPTION_UNDEFINED"] = "SUBSCRIPTION_UNDEFINED";
    SubscriptionStatus["SUBSCRIPTION_ACTIVE"] = "SUBSCRIPTION_ACTIVE";
    SubscriptionStatus["SUBSCRIPTION_CANCELLED"] = "SUBSCRIPTION_CANCELLED";
    SubscriptionStatus["SUBSCRIPTION_FINISHED"] = "SUBSCRIPTION_FINISHED";
    SubscriptionStatus["SUBSCRIPTION_PENDING"] = "SUBSCRIPTION_PENDING";
    SubscriptionStatus["SUBSCRIPTION_SUSPENDED"] = "SUBSCRIPTION_SUSPENDED";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var TransactionStatusStatus;
(function (TransactionStatusStatus) {
    TransactionStatusStatus["UNDEFINED"] = "UNDEFINED";
    TransactionStatusStatus["INITIALIZATION"] = "INITIALIZATION";
    TransactionStatusStatus["INITIALIZED"] = "INITIALIZED";
    TransactionStatusStatus["IN_PROCESS"] = "IN_PROCESS";
    TransactionStatusStatus["APPROVED"] = "APPROVED";
    TransactionStatusStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    TransactionStatusStatus["PENDING_BUYER"] = "PENDING_BUYER";
    TransactionStatusStatus["DECLINED"] = "DECLINED";
    TransactionStatusStatus["FAILED"] = "FAILED";
    TransactionStatusStatus["BUYER_CANCELED"] = "BUYER_CANCELED";
    TransactionStatusStatus["TIMEOUT"] = "TIMEOUT";
    TransactionStatusStatus["REFUND"] = "REFUND";
    TransactionStatusStatus["CHARGE_BACK"] = "CHARGE_BACK";
    TransactionStatusStatus["VOIDED"] = "VOIDED";
    TransactionStatusStatus["AUTHORIZED"] = "AUTHORIZED";
    TransactionStatusStatus["OFFLINE"] = "OFFLINE";
})(TransactionStatusStatus = exports.TransactionStatusStatus || (exports.TransactionStatusStatus = {}));
var TransactionTransactionStatus;
(function (TransactionTransactionStatus) {
    TransactionTransactionStatus["BackofficeTransactionStatusUndefined"] = "BackofficeTransactionStatusUndefined";
    TransactionTransactionStatus["Initialization"] = "Initialization";
    TransactionTransactionStatus["Initialized"] = "Initialized";
    TransactionTransactionStatus["Unknown"] = "Unknown";
    TransactionTransactionStatus["Approved"] = "Approved";
    TransactionTransactionStatus["Declined"] = "Declined";
    TransactionTransactionStatus["GatewayFailure"] = "GatewayFailure";
    TransactionTransactionStatus["Failure"] = "Failure";
    TransactionTransactionStatus["Pending"] = "Pending";
    TransactionTransactionStatus["PendingBuyer"] = "PendingBuyer";
    TransactionTransactionStatus["PendingMerchant"] = "PendingMerchant";
    TransactionTransactionStatus["BuyerCanceled"] = "BuyerCanceled";
    TransactionTransactionStatus["InProcess"] = "InProcess";
    TransactionTransactionStatus["Void"] = "Void";
    TransactionTransactionStatus["ChargeBack"] = "ChargeBack";
    TransactionTransactionStatus["Refund"] = "Refund";
    TransactionTransactionStatus["PartialRefund"] = "PartialRefund";
    TransactionTransactionStatus["CanceledReversal"] = "CanceledReversal";
    TransactionTransactionStatus["Timeout"] = "Timeout";
    TransactionTransactionStatus["Offline"] = "Offline";
    TransactionTransactionStatus["Dispute"] = "Dispute";
    TransactionTransactionStatus["Authorized"] = "Authorized";
})(TransactionTransactionStatus = exports.TransactionTransactionStatus || (exports.TransactionTransactionStatus = {}));
var TransactionTransactionType;
(function (TransactionTransactionType) {
    TransactionTransactionType["BackofficeTransactionTypeUndefined"] = "BackofficeTransactionTypeUndefined";
    TransactionTransactionType["Sale"] = "Sale";
    TransactionTransactionType["Authorization"] = "Authorization";
    TransactionTransactionType["InitializeRecurring"] = "InitializeRecurring";
    TransactionTransactionType["Recurring"] = "Recurring";
})(TransactionTransactionType = exports.TransactionTransactionType || (exports.TransactionTransactionType = {}));
var V1TransactionStatus;
(function (V1TransactionStatus) {
    V1TransactionStatus["UNKNOWN"] = "UNKNOWN";
    V1TransactionStatus["APPROVED"] = "APPROVED";
    V1TransactionStatus["PENDING"] = "PENDING";
    V1TransactionStatus["CANCELED"] = "CANCELED";
    V1TransactionStatus["DECLINED"] = "DECLINED";
    V1TransactionStatus["REFUNDED"] = "REFUNDED";
    V1TransactionStatus["CHARGEBACK"] = "CHARGEBACK";
    V1TransactionStatus["CHARGED_BACK"] = "CHARGED_BACK";
})(V1TransactionStatus = exports.V1TransactionStatus || (exports.V1TransactionStatus = {}));
var V2OrderItemOrderItemCategory;
(function (V2OrderItemOrderItemCategory) {
    V2OrderItemOrderItemCategory["UNDEFINED"] = "UNDEFINED";
    V2OrderItemOrderItemCategory["PHYSICAL"] = "PHYSICAL";
    V2OrderItemOrderItemCategory["DIGITAL"] = "DIGITAL";
})(V2OrderItemOrderItemCategory = exports.V2OrderItemOrderItemCategory || (exports.V2OrderItemOrderItemCategory = {}));
var V2TransactionType;
(function (V2TransactionType) {
    V2TransactionType["SALE"] = "SALE";
    V2TransactionType["RECURRING"] = "RECURRING";
    V2TransactionType["INITIALIZE_RECURRING"] = "INITIALIZE_RECURRING";
})(V2TransactionType = exports.V2TransactionType || (exports.V2TransactionType = {}));
//# sourceMappingURL=types.js.map